import React, { useState, useEffect } from "react";
import "../../css/newBusinesspages.css";
import { getAuth, signOut } from "firebase/auth";
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { firestore, GeoFirestore } from "../../firebase";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useLanguage } from "../../LanguageContext";
import * as text from "../../translation.json";

const auth = getAuth();
const db = firestore;

const SideMenu = ({ page, currentBusiness, user }) => {
  const { language } = useLanguage();
  const [businesses, setBusinesses] = useState([]);

  const fetchUserData = async () => {
    if (!user || !user.admin) return;
    try {
      const businessRef = collection(db, "businesses");
      const q = query(businessRef);
      const querySnapshot = await getDocs(q);
      const businessList = [];
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          businessList.push({ id: doc.id, name: doc.data().name });
          console.log(doc.id, " => ", doc.data().name);
        });
        setBusinesses(businessList);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onSwitchBusiness = async (e) => {
    if (!user?.admin) {
      console.warn("User is not admin; cannot switch business.");
      return;
    }
    const business = [e.id]; // Or just e.id
    const businessName = [e.name]; // Or just e.name
    try {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        businesses: business,
        businessNames: businessName,
      });
      // Prefer updating state/context instead of reload:
      // e.g. setSelectedBusiness(e.id);
      window.location.reload();
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const onNewBusiness = async () => {
    if (!user?.admin) {
      console.warn("User is not admin; cannot switch business.");
      return;
    }
    await updateDoc(doc(db, "users", auth.currentUser.uid), {
      businesses: [],
      businessNames: [],
    });
    // Prefer updating state/context instead of reload:
    // e.g. setSelectedBusiness(e.id);
    window.location.reload();
  };

  return (
    <div className='sidepanelcontainer'>
      <div className='sidePanelMain'>
        <div
          style={{
            marginLeft: 50,
          }}>
          <h3>{!currentBusiness ? "Bedriftsnavn" : currentBusiness}</h3>
          <p>
            <a
              href='/MyBusiness/myLocations'
              style={{
                textDecoration: page === "myLocations" ? "underline" : "",
              }}>
              {user?.studentOrganisasjon
                ? "Min studentforening"
                : text[language].mylocations}
            </a>
          </p>
          {/* <p>
            <a
              href='/MyBusiness/subscription'
              style={{
                textDecoration: page === "subscription" ? "underline" : "",
              }}>
              Premium
            </a>
          </p> */}
          <p>
            <a
              href='/MyBusiness/events'
              style={{
                textDecoration: page === "events" ? "underline" : "",
              }}>
              {text[language].events}
            </a>
          </p>
          {user?.studentOrganisasjonAdmin && (
            <p>
              <a
                href='/MyBusiness/studentAdmin'
                style={{
                  textDecoration: page === "studentAdmin" ? "underline" : "",
                }}>
                Administrasjon av studentforeninger
              </a>
            </p>
          )}
          <p>
            <a
              href='/MyBusiness/statsPage'
              style={{
                textDecoration: page === "statsPage" ? "underline" : "",
              }}>
              {text[language].statistics}
            </a>
          </p>
          <p>
            <a
              href='/MyBusiness/profile'
              style={{
                textDecoration: page === "profile" ? "underline" : "",
              }}>
              {text[language].profile}
            </a>
          </p>
          <p>
            <a
              href='#'
              onClick={() => {
                auth.signOut();
              }}
              style={{
                textDecoration: page === "logOut" ? "underline" : "",
              }}>
              {text[language].logout}
            </a>
          </p>
        </div>
        <div>
          {user?.admin ? (
            <>
              <p onClick={() => onNewBusiness()} style={{ cursor: "pointer" }}>
                New Business
              </p>
              {user?.admin && businesses.length > 0 ? (
                businesses.map((business) => {
                  return (
                    <p
                      onClick={() => onSwitchBusiness(business)}
                      style={{ cursor: "pointer" }}
                      key={business.id}>
                      {business.name}
                    </p>
                  );
                })
              ) : (
                <>
                  <button onClick={() => fetchUserData()}>
                    Fetch User Data
                  </button>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
